'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagLsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.63588e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.00023434 6.66667 3.63588e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0H3.63588e-05L0 6.66667Z",
          fill: "#0C33B8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#1DB158"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6149 9.85004C15.0418 9.62775 15.3333 9.18125 15.3333 8.66668C15.3333 7.9303 14.7363 7.33334 14 7.33334C13.2636 7.33334 12.6666 7.9303 12.6666 8.66668C12.6666 9.18131 12.9582 9.62785 13.3852 9.85011C13.3789 9.86544 13.373 9.88119 13.3676 9.89738L13.3334 10L12.1516 11.7726C12.0635 11.9048 12.0829 12.0791 12.2147 12.1678C12.5084 12.3653 13.1036 12.6667 14.0001 12.6667C14.8966 12.6667 15.4917 12.3653 15.7854 12.1678C15.9172 12.0791 15.9366 11.9048 15.8485 11.7726L14.6667 10L14.6325 9.89738C14.6271 9.88116 14.6212 9.86538 14.6149 9.85004ZM14.6666 8.66668C14.6666 9.03487 14.3681 9.33334 14 9.33334C13.6318 9.33334 13.3333 9.03487 13.3333 8.66668C13.3333 8.29849 13.6318 8.00001 14 8.00001C14.3681 8.00001 14.6666 8.29849 14.6666 8.66668Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagLsAsset = forwardRef(FlagLsAsset);

export { VpFlagLsAsset as default };
